import React, { useEffect } from "react";

import styles from '../Form.module.css'
import RadioSelect from "../inputs/RadioSelect";

import { BsFillCheckCircleFill, BsHandThumbsDownFill, BsHandThumbsUpFill, BsFileText } from 'react-icons/bs'
import { RiTestTubeFill } from 'react-icons/ri'
import { FaPenFancy, FaRegLaugh } from 'react-icons/fa'
import { HiOutlineSpeakerphone } from 'react-icons/hi'
import { GoBook } from 'react-icons/go'
import { IoText } from 'react-icons/io5'


function Step2({ formData, setFormData, setNextButtonState }) {


  useEffect(() => {


    setNextButtonState(
      formData.wasEdTechUser !== null &&
      formData.examPrepPractice !== '' &&
      formData.remembersPeopleBy !== '')


  }, [formData]);



  return (
    <div>
      <div className={styles.header}>
        <h1>Quick questions</h1>
      </div>
      <div className={styles.subFormContainer}>

        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.wasEdTechUser === null ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              Have you ever used a platform for help while studying?
            </div>
            <RadioSelect

              onChange={(data) =>
                setFormData({ ...formData, wasEdTechUser: data })
              }

              value={formData.wasEdTechUser}
              options={[
                { value: 'yes', component: <div>Yes < BsHandThumbsUpFill /></div> },
                {
                  value: 'no', component: <div>No<BsHandThumbsDownFill />
                  </div>
                },]}

              selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
              notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
            />
          </div>
        </div>


        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.examPrepPractice === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              How do you prepare yourself before an exam?
            </div>
            <RadioSelect

              onChange={(data) =>
                setFormData({ ...formData, examPrepPractice: data })
              }

              value={formData.examPrepPractice}
              options={[
                { value: 'outloud', component: <div>Memorizing & Reading OutLoud<HiOutlineSpeakerphone /></div> },
                { value: 'silently', component: <div>Reading silently<GoBook /></div> },
                { value: 'flashcards', component: <div>Writing Notes & Drawing Charts<BsFileText /></div> },]}

              selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
              notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
            />


          </div>
        </div><div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.remembersPeopleBy === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              What do you remember the most in people?
            </div>
            <RadioSelect

              onChange={(data) =>
                setFormData({ ...formData, remembersPeopleBy: data })
              }

              value={formData.remembersPeopleBy}
              options={[
                { value: 'names', component: <div>Their Name<IoText /></div> },
                { value: 'faces', component: <div>Their Faces<FaRegLaugh /></div> },]}

              selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
              notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
            />


          </div>
        </div>
      </div>
    </div>
  );
}

export default Step2;
